import ScriptingEffect from './ScriptingEffect.js';
import {
    execute,
    notes,
    steps,
    prob,
} from './lang.js';
import {pipe} from './pipe.js';

class Notes extends ScriptingEffect {
    constructor(track) {
        super("Notes", track);
        this.newVar('fromNote', 0, -32, 32);
        this.newVar('toNote', 16, -32, 32);
        this.clear();
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            notes(this.var('fromNote'), this.var('toNote')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track=this.track, ignoreId=true) {
        let fx = new Notes(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}

export default Notes;
